import React from 'react';
import { cn } from '../../lib/utils.ts';

type LinkButtonProps = {
    children: React.ReactNode;
    onClick: () => void;
    stopPropagation?: boolean;
    className?: string;
    testId?: string;
};

export function LinkButton({ children, onClick, stopPropagation = false, className, testId }: LinkButtonProps) {
    return (
        <button
            type="button"
            className={cn('text-left text-primary hover:underline', className)}
            data-testid={testId}
            onClick={(event) => {
                if (stopPropagation) {
                    event.stopPropagation();
                }
                onClick();
            }}
        >
            {children}
        </button>
    );
}
